import { object, date, array, boolean, number } from 'yup'
import { AppointmentSlot, AppointmentDate, Appointment, AppointmentAvailability, AppointmentRequest, AppointmentSlotResponse, AppointmentResponse } from './appointment.types'

export const AppointmentSlotSchema = object<AppointmentSlot>().shape({
  startTime: date().required(),
  endTime: date().required(),
})

export const LoadingInfoSchema = object({
  loading: boolean().required(),
  error: boolean().required(),
  lastUpdate: date().optional(),
})

export const AppointmentDateSchema = object<AppointmentDate>().shape({
  date: date().required(),
  slots: array().of(AppointmentSlotSchema).required(),
  loadingInfo: LoadingInfoSchema.required(),
})

export const AppointmentSchema = object<Appointment>().shape({
  date: date().required(),
  slot: AppointmentSlotSchema.required(),
})

export const AppointmentAvailabilitySchema = object<AppointmentAvailability>().shape({
  dates: array().of(AppointmentDateSchema).required(),
})

export const AppointmentRequestSchema = object<AppointmentRequest>().shape({
  latitude: number().required(),
  longitude: number().required(),
  date: date().required(),
})

export const AppointmentSlotResponseSchema = object<AppointmentSlotResponse>().shape({
  appointmentStartTime: date().required(),
  appointmentEndTime: date().required(),
})

export const AppointmentResponseSchema = object<AppointmentResponse>().shape({
  appointmentTimes: array().of(AppointmentSlotResponseSchema).required(),
})
